import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import type { NotificationType } from '../../../../utils/matrixClient';
import { BpLink } from '../../../BpLink/BpLink';
import styles from '../_Flyouts.module.scss';

export const NotificationItem = ({
  notification,
  onClick,
}: {
  notification: NotificationType;
  onClick: (notification: NotificationType) => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles['flyout-item']}>
      <div className={styles.left}>
        <div dangerouslySetInnerHTML={{ __html: notification.content ?? '' }}></div>
      </div>
      <div className={styles.right}>
        <div className={styles.date}>{dayjs(notification.date).fromNow()}</div>
        {notification.targetUrl !== '' && (
          // TODO: check if isEditorOfCourse need more detailed handling!
          <BpLink
            className={styles.link}
            value={t('common.show')}
            onNavigate={() => onClick(notification)}
            isEditorOfCourse={false}
          />
        )}
      </div>
    </div>
  );
};
